/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Tab_BranchesInputs */

const en_client_tab_branches = /** @type {(inputs: Client_Tab_BranchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branches`)
};

const pt_br2_client_tab_branches = /** @type {(inputs: Client_Tab_BranchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filiais`)
};

/**
* | output |
* | --- |
* | "Branches" |
*
* @param {Client_Tab_BranchesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const client_tab_branches = /** @type {((inputs?: Client_Tab_BranchesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Tab_BranchesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_tab_branches(inputs)
	return pt_br2_client_tab_branches(inputs)
});